// Logout handler for clearing auth data on logout
// This script is included in the page and listens for logout events

import { debugLog } from '../modules/jwtTokenManager.js';
import { clearAuthData } from '../modules/preferences.js';

// Function to handle logout
function handleLogout(method = 'unknown') {
  debugLog(`[JWT] Logout initiated via ${method} method`);

  try {
    clearAuthData();
    debugLog('[JWT] Auth data cleared');
  } catch (error) {
    console.error('[JWT] Error clearing auth data during logout:', error);
  }
}

// Listen for logout actions (links and forms)
document.addEventListener('DOMContentLoaded', () => {
  debugLog('[JWT] Logout handler initialized');

  // Find all logout links
  const logoutLinks = document.querySelectorAll('a[href*="/auth/logout"], a[href*="/logout"]');
  debugLog(`[JWT] Found ${logoutLinks.length} logout links on page`);

  logoutLinks.forEach((link, index) => {
    link.addEventListener('click', () => {
      debugLog(`[JWT] Logout link #${index + 1} clicked`);
      handleLogout('link_click');
    });
  });

  // Find all logout forms
  const logoutForms = document.querySelectorAll('form[action*="/logout"]');
  debugLog(`[JWT] Found ${logoutForms.length} logout forms on page`);

  logoutForms.forEach((form, index) => {
    form.addEventListener('submit', () => {
      debugLog(`[JWT] Logout form #${index + 1} submitted`);
      handleLogout('form_submit');
    });
  });

  // If the fb_logout function exists, override it
  if (typeof window.fb_logout === 'function') {
    debugLog('[JWT] Facebook logout function detected, overriding');
    const originalFbLogout = window.fb_logout;
    window.fb_logout = function() {
      debugLog('[JWT] Facebook logout triggered');
      handleLogout('facebook');
      return originalFbLogout.apply(this, arguments);
    };
  }
});

// Also clear auth data if this is the logout page (after redirect from logout action)
if (window.location.pathname.includes('/logout')) {
  debugLog('[JWT] Detected logout page, clearing token');
  handleLogout('logout_page');
}
